import React from 'react';
import { useFinanceStore } from '../api/useFinanceStore';
import { RefreshCw, AlertCircle, CheckCircle2, ArrowLeftRight, Trash2 } from 'lucide-react';
import { formatZAR } from '../../../utils/formatters';

const ReconciliationEngine: React.FC = () => {
    const { reconciliation, resolveReconciliation, deleteReconciliation } = useFinanceStore();

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h3 className="text-lg font-bold text-slate-800 uppercase tracking-tight">Reconciliation</h3>
                <div className="flex gap-2 items-center">
                    <span className="px-3 py-1 bg-slate-100 text-slate-600 rounded-full text-[10px] font-black uppercase tracking-widest">
                        {reconciliation.filter(r => r.status === 'matched').length}/{reconciliation.length} Resolved
                    </span>
                    <button className="p-2 bg-slate-100 text-slate-600 rounded-xl hover:bg-slate-200 transition-all">
                        <RefreshCw size={16} />
                    </button>
                </div>
            </div>

            <div className="grid gap-4">
                {reconciliation.length === 0 ? (
                    <div className="p-10 text-center bg-slate-50 rounded-2xl border border-dashed border-slate-300 text-slate-400 font-medium">
                        No reconciliation items. Run the finance migration to populate the Reconciliation_Log tab.
                    </div>
                ) : (
                    reconciliation.map(item => (
                        <div key={item.id} className="p-4 bg-white rounded-2xl shadow-sm border border-slate-200 flex items-center justify-between group hover:border-blue-300 transition-all">
                            <div className="flex items-center gap-4">
                                <div className={`p-3 rounded-xl ${item.status === 'matched' ? 'bg-green-100 text-green-600' : item.status === 'mismatch' ? 'bg-red-100 text-red-600' : 'bg-slate-100 text-slate-600'}`}>
                                    {item.status === 'matched' ? <CheckCircle2 size={20} /> : <AlertCircle size={20} />}
                                </div>
                                <div className="text-sm">
                                    <div className="font-bold text-slate-800">{formatZAR(item.amount)} <span className="text-slate-400 font-normal ml-2">• {item.date}</span></div>
                                    <div className="text-[10px] text-slate-400 uppercase font-black tracking-widest">
                                        {item.source || 'Unknown'} → {item.destination || 'Unknown'}
                                    </div>
                                    <div className="text-[10px] text-slate-500 mt-0.5">
                                        Status: <span className="font-bold">{item.status}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                {item.status !== 'matched' && (
                                    <button
                                        onClick={() => resolveReconciliation(item.id)}
                                        className="flex items-center gap-2 px-3 py-2 bg-slate-800 text-white rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-slate-900 transition-all active:scale-95"
                                    >
                                        <ArrowLeftRight size={12} /> Resolve
                                    </button>
                                )}
                                <button
                                    onClick={() => deleteReconciliation(item.id)}
                                    className="p-2 text-slate-400 hover:text-red-500 transition-colors"
                                    title="Delete"
                                >
                                    <Trash2 size={14} />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ReconciliationEngine;
